// extracted by mini-css-extract-plugin
export default {"wrapper":"data-account-error-modal_wrapper__HdL+O","button":"data-account-error-modal_button__veWzE","opacity-transition":"data-account-error-modal_opacity-transition__jr4oD"};